import React from 'react';
import { some } from 'lodash';
import moment from 'moment';
import DateFormat from 'constants/date_format';
import Select from '../../shared/select';

const VALUE_FORMAT = DateFormat.fixed.DATE_SELECT_TIME;

class TimeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  static defaultProps = {
    step: [15, 'minute'],
  };

  get selectedValue() {
    return moment.parseZone(this.props.value).format(VALUE_FORMAT);
  }

  getOptionProps(date) {
    const { max, min, step } = this.props;
    return {
      value: date.format(VALUE_FORMAT),
      children: date.format(DateFormat.TIME),
      disabled: some([
        min && date.isSameOrBefore(min),
        max &&
          date
            .clone()
            .add(...step)
            .isAfter(max),
      ]),
    };
  }

  getOptions() {
    const { step } = this.props;
    const options = [];
    const startDate = moment(this.props.value).startOf('day');
    const endDate = moment(startDate).set({ hour: 23, minute: 45 });
    const date = startDate;
    while (endDate.isAfter(date)) {
      options.push(this.getOptionProps(date));
      date.add(...step);
    }
    return [...options, this.getOptionProps(endDate)];
  }

  handleOnChange(e) {
    const date = moment.parseZone(this.props.value);
    const time = moment(e.target.value, VALUE_FORMAT);
    date.set({
      hour: time.get('hour'),
      minute: time.get('minute'),
    });
    if (this.props.onChange) {
      this.props.onChange(date, e);
    }
  }

  render() {
    return (
      <Select
        className={this.props.className || ''}
        id={this.props.id}
        onChange={this.handleOnChange}
        value={this.selectedValue}
        disabled={this.props.disabled}
        ariaRequired={this.props.ariaRequired}
        ariaLabel={this.props.ariaLabel}
        name={this.props.selectName}
      >
        {this.getOptions().map(option => (
          <option key={option.value} {...option} aria-label={option.value} />
        ))}
      </Select>
    );
  }
}

export default TimeSelect;
